export { default } from './ArticleItemCover';
